/**
 * Share Service - Web Share API and image download utilities
 */

// Web Share API로 이미지 공유
export const shareImage = async (blob, title) => {
  const file = new File([blob], 'study-card.png', { type: 'image/png' });
  if (navigator.canShare?.({ files: [file] })) {
    await navigator.share({ files: [file], title });
    return 'shared';
  }
  return 'unsupported';
};

// 이미지 다운로드
export const downloadImage = (blob, filename = 'study-card.png') => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Canvas element -> Blob 변환
export const canvasToBlob = (canvas) => {
  return new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
};

// 비디오 공유
export const shareVideo = async (blob, title) => {
  const file = new File([blob], 'study-timelapse.webm', { type: 'video/webm' });
  if (navigator.canShare?.({ files: [file] })) {
    await navigator.share({ files: [file], title });
    return 'shared';
  }
  return 'unsupported';
};

// Web Share API 지원 여부
export const isShareSupported = () => {
  return !!navigator.share && !!navigator.canShare;
};
